export default {
  heading1: 'News',
  heading: 'Latest news',
  readMore: 'Read more'
}